import React from "react";
import styles from "./HeroSection.module.css";
import Image from "../assets/images/resultshowcase.png";

function HeroSection() {
  return (
   <> 
     <div
      id="Home"
      className={`${styles.container} w-screen h-screen flex flex-col justify-center items-center`}
    >
      <img src={Image} alt="Hero-side-Image" className={`${styles.cornerImg} absolute top-20 right-7 w-48 h-48 rotate object-cover hidden sm:block`} />
      <h1 className="text-lg sm:text-3xl lg:text-5xl font-sinhalaPrimary text-center">
        වසර කිහිපයක් අතුලත අඛණ්ඩව ප්‍රතිඵල 100%
        <br />
        පෙන්වූ විද්‍යා පන්තිය
      </h1>
      <h2 className="text-lg sm:text-3xl lg:text-4xl font-sinhalaTertiary text-center mt-4">
        විශිෂ්ඨයෙකු වන්නට ඔබත් එක් වන්න
      </h2>
      <button className="bg-yellow font-sinhalaPrimary py-2 px-4 rounded-lg mt-4 font-black">
        පන්ති පිළිබද විස්තර
      </button>
    </div>
   </>
  );
}

export default HeroSection;
